<template>
  <div class="comment_fill">
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      class="demo-ruleForm"
    >
      <h3>Добавить комментарий:</h3>
      <el-form-item prop="text">
        <el-input v-model="ruleForm.text" type="textarea" />
      </el-form-item>
      <el-form-item prop="isPositive">
        <el-radio-group v-model="ruleForm.isPositive">
          <el-radio label="1" class="radio-img">
            <img src="@/assets/img/like.svg" alt="like" class="img-comment" />
            <span>Положительно</span>
          </el-radio>
          <el-radio label="0" class="radio-img">
            <img
              src="@/assets/img/dislike.svg"
              alt="dislike"
              class="img-comment"
            />
            <span>Отрицательно</span>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item class="buttons-block">
        <el-button
          :loading="loading"
          type="primary"
          @click="submitForm('ruleForm')"
        >
          Добавить
        </el-button>
        <el-button :disabled="loading" @click="resetForm('ruleForm')">
          Отменить
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'

const Comments = RepositoryFactory.get('comments')

export default {
  name: 'CommentFill',
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      ruleForm: {
        isPositive: '1',
        text: '',
      },
      rules: {
        isPositive: [
          { required: true, message: 'Дайте оценку', trigger: 'change' },
        ],
        text: [
          {
            required: true,
            message: 'Поле комментария должно быть заполненно',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          const data = {
            response_id: this.id,
            is_positive: Number(this.ruleForm.isPositive),
            text: this.ruleForm.text,
          }

          Comments.addComment(data)
            .then(() => this.$message.success('Комментарий успешно добавлен'))
            .catch(e => {
              this.$message.error('Ошибка! Комментарий не добавлен.')
              console.log(`[fetchComments] err: `, e)
            })
            .finally(() => {
              this.$emit('closeModalComment')
              this.ruleForm.isPositive = '1'
              this.ruleForm.text = ''
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.ruleForm.isPositive = '1'
      this.ruleForm.text = ''
      this.$emit('closeModalComment')
    },
  },
}
</script>
<style lang="sass">
.passport_dialog_window
  font-family: 'Rubik', sans-serif
  .el-dialog
    max-width: 800px
.comment_fill
  font-family: "Rubik", sans-serif
  .img-comment
    margin-right: 6px
  h3
    margin-bottom: 16px
  .buttons-block
    display: flex
    justify-content: flex-end
    align-items: center
</style>
